import React, { useEffect, useState } from 'react';
import { getAuth } from 'firebase/auth';
import { getFirestore, collection, query, where, getDocs } from 'firebase/firestore';
import BackHomeButton from '../components/BackHomeButton';
import { db, auth } from '../firebase';

function UserPendingDownloadPage() {
  const [downloads, setDownloads] = useState([]);
  const [filteredDownloads, setFilteredDownloads] = useState([]);
  const [loading, setLoading] = useState(true);
  const [documentTypeFilter, setDocumentTypeFilter] = useState('All');
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const downloadsPerPage = 5;
  

  useEffect(() => {
    const fetchDownloads = async () => {
      const auth = getAuth();
      const user = auth.currentUser;

      if (user) {
        //const db = getFirestore();
        const downloadsRef = collection(db, 'uploads');
        const downloadsQuery = query(downloadsRef, where('uid', '==', user.uid));
        const querySnapshot = await getDocs(downloadsQuery);

        const userDownloads = querySnapshot.docs
          .map(doc => ({ id: doc.id, ...doc.data() }))
          .sort((a, b) => (b.uploadTime?.seconds || 0) - (a.uploadTime?.seconds || 0));

        setDownloads(userDownloads);
        setFilteredDownloads(userDownloads);
      }

      setLoading(false);
    };

    fetchDownloads();
  }, []);

useEffect(() => {
  let filtered = downloads;

  if (searchTerm.trim()) {
    filtered = filtered.filter(d => {
      const fileMatch =
        (d.fileName || "")
          .toLowerCase()
          .includes(searchTerm.toLowerCase());

      const topicMatch =
        Array.isArray(d.topicName?.current) &&
        d.topicName.current.some(topic =>
          topic.toLowerCase().includes(searchTerm.toLowerCase())
        );

      return fileMatch || topicMatch;
    });
  }

  setFilteredDownloads(filtered);
  setCurrentPage(1);
}, [documentTypeFilter, searchTerm, downloads]);


  const indexOfLast = currentPage * downloadsPerPage;
  const indexOfFirst = indexOfLast - downloadsPerPage;
  const currentDownloads = filteredDownloads.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(filteredDownloads.length / downloadsPerPage);

  if (loading) return <div>Loading...</div>;

  return (
    <div style={styles.container}>
      <BackHomeButton style={{ marginTop: '2rem' }} />

      <h2>Your Pending Worksheets</h2>

      <div style={styles.filterSearchContainer}>
    {/*    <div>
          <label><strong>Filter by Type:</strong> </label>
          <select
            value={documentTypeFilter}
            onChange={(e) => setDocumentTypeFilter(e.target.value)}
            style={styles.selectInput}
          >
            <option value="All">All</option>
          </select>
        </div>
    */}
        <input
          type="text"
          placeholder="Search by Topic Name"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={styles.searchInput}
        />
      </div>

      {currentDownloads.length === 0 ? (
        <p>No downloads found.</p>
      ) : (
        currentDownloads.map((download) => {
          const date = download.uploadTime?.seconds
            ? new Date(download.uploadTime.seconds * 1000).toLocaleDateString()
            : 'Unknown date';

          return (
            <div key={download.id} style={styles.uploadBox}>
              {/*
                <h3>
                {download.calculatedFileName || download.fileName || 'Untitled File'}
                {download.subject ? ` - ${download.subject}` : ''}
                <span style={styles.dateStyle}>
                Last Downloaded:{' '}
                {download.timestamp?.seconds
                    ? new Date(download.timestamp.seconds * 1000).toLocaleString()
                    : 'Unknown date'}
                </span>

                </h3>  */}

              <div style={styles.details}>
                <strong>Type</strong> : {download.type}<br/>
                <strong>File_Name</strong> : {download.fileName}<br/>
                <strong>Lesson</strong>: {download.lessonName}<br/>
                <strong>Uploaded By</strong>: {download.uploadedBy}<br />
                <strong>School</strong>: {download.school}<br />
                <strong>Standard</strong>: {download.standard} <br />
                <strong>Topics</strong>: {download.topicName.current}<br />
                
               {/* {download.uploadTime && <>Uploaded on: {download.uploadTime.toLocaleDateString()}</>} */}
              </div>
              <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                <a
                  href={download.fileUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={styles.downloadLink}
                >
                  View and Download
                </a>
              </div>
            </div>
          );
        })
      )}

      {totalPages > 1 && (
        <div style={styles.pagination}>
          <button
            disabled={currentPage === 1}
            onClick={() => setCurrentPage(prev => prev - 1)}
            style={styles.pageButton}
          >
            Prev
          </button>
          <span style={{ margin: '0 10px' }}>
            Page {currentPage} of {totalPages}
          </span>
          <button
            disabled={currentPage === totalPages}
            onClick={() => setCurrentPage(prev => prev + 1)}
            style={styles.pageButton}
          >
            Next
          </button>
        </div>
      )}

      <br /><br /><br /><br />

      <footer style={styles.footer}>
        <p style={styles.footerText}>© 2026 Eascode All Rights Reserved.</p>
      </footer>
    </div>
  );
}

const styles = {
  container: {
    maxWidth: '700px',
    margin: 'auto',
    padding: '20px',
  },
  filterSearchContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '20px',
    flexWrap: 'wrap',
    gap: '10px',
  },
  selectInput: {
    padding: '8px',
    borderRadius: '4px',
    border: '1px solid #ccc',
  },
  searchInput: {
    padding: '8px',
    borderRadius: '4px',
    border: '1px solid #ccc',
    flex: 1,
    minWidth: '200px',
  },
  uploadBox: {
    border: '1px solid #ddd',
    borderRadius: '8px',
    padding: '15px',
    marginBottom: '15px',
    backgroundColor: '#f9f9f9',
  },
  dateStyle: {
    marginLeft: '10px',
    fontSize: '0.9rem',
    color: '#888',
  },
  downloadLink: {
    display: 'inline-block',
    marginTop: '10px',
    padding: '8px 16px',
    backgroundColor: '#4CAF50',
    color: '#fff',
    textDecoration: 'none',
    borderRadius: '4px',
  },
  pagination: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '20px 0',
  },
  pageButton: {
    padding: '8px 12px',
    backgroundColor: '#007bff',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    minWidth: '70px',
  },
  footer: {
    padding: '1rem',
    backgroundColor: '#333',
    color: '#fff',
    textAlign: 'center',
  },
  footerText: {
    fontSize: '0.9rem',
  },
};

export default UserPendingDownloadPage;
